<template>
    <div class="dealWithBox">
        <div class="detailedInformation">
            <div class="deatlisName">
                <p style="border: 1px solid rgb(59, 99, 246);"></p>
                <h4>案件详情（调解）</h4>
            </div>
            <div class="deatlisContent">
                <!--                申请人-->
                <div class="beAppliedBox">
                    <div class="beApplied">
                        <p>申请人:</p>
                        <span>{{caseContent.shenqing_info}}</span>
                    </div>
                </div>
                <!--                被申请人-->
                <div class="applicantBox" v-for="(item,index) in bei_info" :key="index">
                    <div class="applicant">
                        <p>被申请人:</p>
                        <span>{{item}}</span>
                    </div>
                </div>
                <div class="caseStatusBox">
                    <div class="caseStatus">
                        <p>案件编号:</p>
                        <span>{{caseContent.case_sn}}</span>
                    </div>
                    <div class="caseNo">
                        <p>合同名称:</p>
                        <span>{{caseContent.doc_title}}</span>
                    </div>
                    <div class="registerTime">
                        <p>合同编号:</p>
                        <span>{{caseContent.contract_sn}}</span>
                    </div>
                </div>
                <div class="reasonBox">
                    <div class="reason">
                        <p>案由:</p>
                        <span>{{caseContent.an_you}}</span>
                    </div>
                    <div class="contractType">
                        <p>合同类型:</p>
                        <span>{{caseContent.product_name}}</span>
                    </div>
                    <div class="money">
                        <p>涉案金额:</p>
                        <span>{{caseContent.money}}元</span>
                    </div>
                </div>
                <!--                日期-->
                <div class="datebox">
                    <div class="date">
                        <p>签订日期:</p>
                        <span>{{caseContent.sign_time}}</span>
                    </div>
                    <div class="submit">
                        <p>提交案件时间:</p>
                        <span>{{caseContent.tijiao_time}}</span>
                    </div>
                    <div class="status">
                        <p>案件状态:</p>
                        <span style="color: red">{{caseContent.status_txt}}</span>
                    </div>
                </div>
                <!--                代理人-->
                <div class="agentBox">
                    <div class="agent">
                        <p>代理人:</p>
                        <span>{{caseContent.lawyer_name}}</span>
                    </div>
                    <div class="mechanism">
                        <p>仲裁机构:</p>
                        <span>{{caseContent.zhcaiwei_name}}</span>
                    </div>
                    <!--                    <div class="fileCase">-->
                    <!--                        <p>立案秘书:</p>-->
                    <!--                        <span>{{caseContent.lian_staff_name}}</span>-->
                    <!--                    </div>-->
                </div>
                <!--                立案时间-->
                <div class="timeBox">
                    <div class="time">
                        <p>立案时间:</p>
                        <span>{{caseContent.lian_time}}</span>
                    </div>
                    <div class="expense">
                        <p>仲裁费:</p>
                        <span>{{caseContent.fees}}元</span>
                    </div>
                    <!--                    <div class="handleCase">-->
                    <!--                        <p>办案秘书:</p>-->
                    <!--                        <span>{{caseContent.banan_staff_name}}</span>-->
                    <!--                    </div>-->
                </div>
                <!--                仲裁员-->
                <div class="arbitratorBox">
                    <div class="arbitrator">
                        <p>仲裁员:</p>
                        <span>{{caseContent.zhcai_staff_name}}</span>
                    </div>
                    <div class="reply">
                        <p>答辩期结束时间:</p>
                        <span>{{caseContent.dabian_end_time}}</span>
                    </div>
                    <div class="trial">
                        <p>审理期结束时间:</p>
                        <span>{{caseContent.shenli_end_time}}</span>
                    </div>
                </div>
                <!--               结案时间 -->
                <div class="closeCaseBox">
                    <div class="caseNumber">
                        <p>仲裁案号</p>
                        <span>{{caseContent.zhcai_sn}}</span>
                    </div>
                    <div class="closeCase">
                        <p>结案时间:</p>
                        <span>{{caseContent.jie_an_time}}</span>
                    </div>
                </div>
            </div>
            <!--            申请人证据清单-->
            <div v-if="caseContent.company_id!==0">
                <div class="titleBox">
                    <div class="deatlisName">
                        <p style="border: 1px solid rgb(59, 99, 246);"></p>
                        <h4>企业身份证明列表</h4>
                    </div>
                    <el-button class="customize" @click="applicantEvidence">下载证据</el-button>
                </div>
                <div style="margin-bottom: 30px">
                    <avue-crud :data="applicantList" :option="applicantData" ></avue-crud>
                </div>
            </div>
            <!--            证据清单列表-->
            <div>
                <div class="titleBox">
                    <div class="deatlisName">
                        <p style="border: 1px solid rgb(59, 99, 246);"></p>
                        <h4>证据清单列表</h4>
                    </div>
                    <el-button class="customize" @click="downloadEvidence">下载证据</el-button>
                </div>
                <div style="margin-bottom: 30px">
                    <avue-crud :data="data" :option="option" ></avue-crud>
                </div>
            </div>
            <!--            申请人其他证据列表-->
            <div>
                <div class="titleBox">
                    <div class="deatlisName">
                        <p style="border: 1px solid rgb(59, 99, 246);"></p>
                        <h4>申请人其他证据列表</h4>
                    </div>
                    <el-button class="customize" @click="downloadOtherProof">下载证据</el-button>
                </div>
                <div style="margin-bottom: 30px">
                    <avue-crud :data="applicantOtherProof" :option="otherProof" >
                        <template slot="menu" slot-scope="scope" >
                            <el-button class="view" @click="preview(scope.row)">预览</el-button>
                        </template>
                    </avue-crud>
                </div>
            </div>
            <!--            补充证据清单-->
            <div>
                <div class="titleBox">
                    <div class="deatlisName">
                        <p style="border: 1px solid rgb(59, 99, 246);"></p>
                        <h4>补充证据列表</h4>
                    </div>
                    <el-button class="customize" @click="download">下载证据</el-button>
                </div>
                <div style="margin-bottom: 30px">
                    <avue-crud :data="detailedList" :option="supplement" ></avue-crud>
                </div>
            </div>
            <!--            仲裁文书列表-->
            <div>
                <div class="titleBox">
                    <div class="deatlisName">
                        <p style="border: 1px solid rgb(59, 99, 246);"></p>
                        <h4>仲裁文书列表</h4>
                    </div>
                    <el-button class="customize" @click="downloadDocument">下载文书</el-button>
                </div>
                <div style="margin-bottom: 30px">
                    <avue-crud :data="list" :option="arbitration" >
                        <template slot="menu" slot-scope="scope" >
                            <el-button class="view" @click="preview(scope.row)">预览</el-button>
                        </template>
                    </avue-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        arbitrationDocument_center,
        downloadList_center,
        identityCertificate_center,
        mediationDetails_center, otherEvidence_center, supplementaryEvidence_center
    } from '../../../api/mediationCenter';

    export default {
        name: 'details_center',
        data() {
            return {
                caseContent:'',
                data: [
                ],
                list:[],
                detailedList:[],
                bei_info:[],
                beApplied:[],
                applicantList:[],   //申请人证据列表
                applicantOtherProof:[],  //申请人其他证据列表
                applicantData:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    menu:false,     //是否显示操作栏
                    column:[
                        {
                            label:'证据名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        }
                    ]
                },
                //证据清单列表
                option:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    menu:false,     //是否显示操作栏
                    column:[
                        {
                            label:'合同类型',
                            prop:'product_name'
                        }, {
                            label:'证据分类',
                            prop:'product_two_name'
                        }, {
                            label:'证据名称',
                            prop:'product_min_name'
                        }, {
                            label:'证据内容',
                            prop:'content_txt'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        }
                    ]
                },
                //仲裁文书列表
                arbitration:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    // menu:false,     //是否显示操作栏
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'是否需要签章',
                            prop:'is_need_sign_txt'
                        }, {
                            label:'是否已签章',
                            prop:'is_sign_txt'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                //补充证据清单
                supplement:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    menu:false,     //是否显示操作栏
                    column:[
                        {
                            label:'合同类型',
                            prop:'product_name'
                        }, {
                            label:'证据名称',
                            prop:'product_min_name'
                        }, {
                            label:'证据内容',
                            prop:'content_txt'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                //申请人其他证据列表
                otherProof:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:240,  //操作栏宽度设置
                    column:[
                        {
                            label:'文书名称',
                            prop:'name'
                        }, {
                            label:'是否需要签章',
                            prop:'is_need_sign_txt'
                        }, {
                            label:'是否已签章',
                            prop:'is_sign_txt'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
            };
        },
        methods:{
            //下载企业身份证明
            applicantEvidence(){
                identityCertificate_center({case_id:this.$route.query.id}).then(res=>{
                    if (res.code==200){
                        const link = document.createElement("a"); //自己创建的a标签
                        link.href = res.data.download_url;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(res.data.download_url);
                        this.$message.success(res.msg);
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //下载证据清单列表
            downloadEvidence(){
                downloadList_center({case_id:this.$route.query.id}).then(res=>{
                    if (res.code==200){
                        const link = document.createElement("a"); //自己创建的a标签
                        link.href = res.data.download_url;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(res.data.download_url);
                        this.$message.success(res.msg);
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //下载申请人其他证据
            downloadOtherProof(){
                otherEvidence_center({case_id:this.$route.query.id}).then(res=>{
                    if (res.code==200){
                        const link = document.createElement("a"); //自己创建的a标签
                        link.href = res.data.download_url;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(res.data.download_url);
                        this.$message.success(res.msg);
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //预览
            preview(){
                const link = document.createElement("a"); //自己创建的a标签
                link.href = row.all_url+'?v='+Math.random();
                link.target="_blank"
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(row.all_url);
            },
            //下载补充证据
            download(){
                supplementaryEvidence_center({case_id:this.$route.query.id}).then(res=>{
                    if (res.code==200){
                        const link = document.createElement("a"); //自己创建的a标签
                        link.href = res.data.download_url;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(res.data.download_url);
                        this.$message.success(res.msg);
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //下载仲裁文书
            downloadDocument(){
                arbitrationDocument_center({case_id:this.$route.query.id}).then(res=>{
                    if (res.code==200){
                        const link = document.createElement("a"); //自己创建的a标签
                        link.href = res.data.download_url;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(res.data.download_url);
                        this.$message.success(res.msg);
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            }
        },
        created() {
            mediationDetails_center({case_id:this.$route.query.id}).then(res=>{
                if(res.code==200){
                    this.caseContent=res.data
                    this.bei_info=res.data.bei_info
                    this.data=res.data.evidence_list
                    this.list=res.data.wenshu_list
                    this.detailedList=res.data.evidence_extra_list
                    this.beApplied=res.data.evidence_bei_list
                    this.applicantList=res.data.com_evi_list
                    this.applicantOtherProof=res.data.sqrqita_list
                    this.agent=res.data.dailiren_list
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    };
</script>

<style scoped>
    p{
        flex-shrink:0
    }
    .dealWithBox{
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }
    p{
        color: #9f9fa2;
        margin-right: 10px;
    }
    span{
        color: #535354;
    }
    .deatlisName{
        margin-right: 10px;
        display: flex;
    }
    .deatlisName>h4{
        color: #3b63f6;
        width: 150px;
        /*margin-bottom: 10px;*/
    }
    .deatlisName>p{
        width: 5px;
        height: 18px;
        background: #3B63F6;
    }
    .titleBox{
        display: flex;
        align-items: center;
        margin: 10px 0px;
    }
    /*标题下边内容*/
    .deatlisContent{
        padding: 5px;
        font-size: 14px;
    }
    .caseStatus,
    .caseNo,
    .registerTime,
    .caseNumber,
    .closeCase{
        display: flex;
        width: 30%;
    }

    .caseStatusBox{
        display: flex;
        padding: 5px 0px;
    }
    /*    立案秘书*/
    .beAppliedBox{
        display: flex;
        padding: 5px 0px;

    }
    .beApplied{
        display: flex;
    }
    /*申请人*/
    .applicantBox,
    .reasonBox,
    .datebox,
    .agentBox,
    .timeBox,
    .arbitratorBox,
    .closeCaseBox,
    .eventBox,
    .factBox{
        display: flex;
        padding: 5px 0px;

    }
    .applicant{
        display: flex;
    }
    .closeCase,
    .event,
    .fact{
        display: flex;
    }
    .reason,
    .contractType,
    .money,
    .date,
    .submit,
    .status,
    .agent,
    .mechanism,
    .fileCase,
    .handleCase,
    .time,
    .expense,
    .arbitrator,
    .reply,
    .trial{
        display: flex;
        width: 30%;
    }
    .customize{
        background-color: #3b63f6;
        color: #FFFFFF;
    }
    .view{
        background-color: #3b63f6;
        color: #FFFFFF;
    }
    ::v-deep .avue-crud__menu{
        min-height: 0px;
    }
</style>
